<template>
  <el-aside class="app-sidebar" :class="{'app-sidebar-narrow': sidebarSwitch}">
    <section class="app-sidebar-wrap">
      <!--      <h2 class="sidebar-title"><i><img alt="logo" :src="logo"></i>张江能源中心</h2>-->
      <el-row>
        <el-menu :default-active="menuActive" class="app-sidebar-vertical" :router="menuRouter" :unique-opened="menuUniqueOpen" :collapse="sidebarSwitch" :collapse-transition="collapseTransition" background-color="#E4E8F3">

          <template v-for="(item, index) in menuConfig">
            <!-- 此处的index需显示转换为string，否则会报warn -->
            <template v-if="!item.meta.hidden">
              <!--不是首页时-->
              <template v-if="hasShowingChild(item) && isNotHomePage(item)">
                <el-submenu :index="item.meta.name" :key="index">
                  <template slot="title">
                    <i :class="item.meta.icon | iconClass"></i>
                    {{ item.meta.title }}
                  </template>
                  <template v-for="(subItem, i) in item.children">
                    <template
                    v-if="((!subItem.meta.hidden && subItem.meta.permission && needPagePermission) ||
                    (!subItem.meta.hidden && !needPagePermission)) && !subItem.children">
                      <router-link tag="span" :to="item.path + '/' + subItem.path" :key="i">
                        <el-menu-item :index="subItem.meta.name"><i :class="subItem.meta.icon | iconClass"></i>{{ subItem.meta.title}}</el-menu-item>
                      </router-link>
                    </template>
                    <!-- 原代码兼容三级 本来想改造成递归组件 先上一版让测试验证 之后再改吧-->
                    <template
                    v-else-if="(!subItem.meta.hidden && subItem.meta.permission && needPagePermission) ||
                    (!subItem.meta.hidden && !needPagePermission) && subItem.children">
                      <el-submenu
                      :index="subItem.meta.name"
                      :key="i"
                      class="subItem"
                      >
                        <template slot="title">
                          <i :class="subItem.meta.icon | iconClass"></i>
                              {{ subItem.meta.title }}
                        </template>
                        <template v-for="(grandsonItem, ind) in subItem.children">
                          <router-link tag="span" :to="item.path + '/' + subItem.path + '/' + grandsonItem.path" :key="ind">
                          <el-menu-item :index="grandsonItem.meta.name" v-if="grandsonItem.meta.hidden"><i :class="grandsonItem.meta.icon | iconClass"></i>{{ grandsonItem.meta.title }}{{grandsonItem.hidden }}</el-menu-item>
                          </router-link>
                        </template>
                      </el-submenu>
                    </template>
                  </template>
                </el-submenu>
              </template>
              <!--是首页-->
              <template v-else-if="hasShowingChild(item) && !isNotHomePage(item)">
                <router-link tag="span" :to="item.path" :key="index">
                  <el-menu-item :index="item.meta.name">
                    <i :class="item.meta.icon | iconClass"></i>
                    {{ item.meta.title }}
                  </el-menu-item>
                </router-link>
              </template>
              <!-- 没有二级菜单的情况 -->
              <template v-else>
                <router-link tag="span" :to="item.path" :key="index">
                  <el-menu-item :index="item.meta.name">
                    <i :class="item.meta.icon | iconClass"></i>
                    {{ item.meta.title }}
                  </el-menu-item>
                </router-link>
              </template>
            </template>
          </template>
        </el-menu>
      </el-row>
    </section>
  </el-aside>
</template>

<script>
import menuArray from '@/router/menu'
import logo from '@/assets/logo.png'
import { mapState } from 'vuex'

export default {
  name: 'sidebar',
  data () {
    return {
      menuConfig: [],
      menuRouter: false,
      menuUniqueOpen: true,
      collapseTransition: false,
      pagePermission: [],
      needPagePermission: this.$conf.needPagePermission,
      logo
    }
  },
  mounted () {
    let arr = JSON.parse(JSON.stringify(menuArray))
    if (this.$conf.needPagePermission) {
      // 此处page在项目中应该为登录后获取
      this.pagePermission = this.$base.getUserPagePermission()
      this.menuConfig = this.checkPermission(arr)
    } else {
      this.menuConfig = arr
    }
  },
  filters: {
    iconClass: function (value) {
      if (!value) return ''
      value = value.toString()
      return 'el-icon-' + value
    }
  },
  computed: mapState({
    sidebarSwitch: (state) => !state.sidebarSwitch,
    menuActive: state => state.menuActive
  }),
  methods: {
    hasShowingChild (item) {
      // 如果使用了children，但并不需要显示children
      if (item.children) {
        if (item.children.length > 1) {
          return true
        } else if (item.children.length === 1) {
          return item.children[0].meta.title
        } else {
          return false
        }
      }
    },
    // 不是首页
    isNotHomePage (item) {
      if (item.name === 'overview') {
        return false
      } else {
        return true
      }
    },
    checkPermission (list) {
      // 权限检查
      let newList = [...list]
      list.forEach((item, index) => {
        if (this.pagePermission.some(i => i.indexOf(item.path) > -1)) {
          newList[index].meta.permission = true
          if (item.children && item.children.length) {
            item.children.forEach((item2, i) => {
                if (!item2.meta.title) {
                  newList[index].children[i].meta.permission = true
                } else {
                  newList[index].children[i].meta.permission = this.pagePermission.indexOf(item.path + '/' + item2.path) > -1
                }
                if (item2.children && item2.children.length) {
                  item2.children.forEach((item3, i2) => {
                    if (this.pagePermission.some(i => i.indexOf(item3.path) > -1)) {
                      newList[index].children[i].children[i2].meta.hidden = true
                    } else {
                      newList[index].children[i].children[i2].meta.hidden = false
                    }
                  })
                }
            })
          }
        } else {
          newList[index].meta.permission = false
          if (item.children && item.children.length) {
            let count = 0 // count计数判断是否隐藏二级菜单
            item.children.forEach((item2, i) => {
              if (this.pagePermission.indexOf(item.path + '/' + item2.path) > -1) {
                newList[index].children[i].meta.permission = true
              } else {
                count++
                newList[index].children[i].meta.permission = false
              }
            })
            if (count === item.children.length) {
              newList[index].meta.hidden = true
            }
          }
        }
      })
      return newList
    }
  }
}
</script>

<style lang="scss" scoped>
.app-sidebar {
  padding-right: 10px;
  width: 2.4rem !important;
  height: 100%;
  overflow: hidden;
  z-index: 1999;
  box-sizing: border-box;

  .app-sidebar-vertical {
    text-align: left;
  }

  &.app-sidebar-narrow {
    width: 0.56rem !important;
    /*transition: all ease-in-out 0.3s;*/
  }

  .app-sidebar-wrap {
    background-color: #E4E8F3;
    width: 2.4rem;
    height: 100%;
    overflow: hidden;
    .sidebar-title {
      height: 0.6rem;
      line-height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      font-weight: normal;
      color: #4F4D78;
      i {
        margin-right: 0.2rem;
      }
      img {
        width: 0.18rem;
      }
    }
    .el-row {
      overflow-x: hidden;
      overflow-y: auto;
      color: #E4E8F3;
      height: 100%;
    }
    /*滚动条样式*/
    .el-row::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }
    .el-row::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 5px;
      box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: rgba(255, 255, 255, 0.2);
    }
    .el-row::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.1);
      border-radius: 0;
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .el-menu {
    border-right: none;
  }

  .iconfont {
    vertical-align: middle;
    margin-right: 0.2rem;
    text-align: center;
    font-size: 0.18rem;
  }
  /*二级菜单的字体大小*/
  .longTitle{
    /*font-size: 0.12rem!important;*/
  }
  .el-menu-item,
  /deep/ .el-submenu__title {
    width: 2.4rem;
    min-width: auto;
    height: 0.5rem;
    line-height: 0.5rem;
    padding: 0 0.2rem !important;
    /*color: rgba(255, 255, 255, 0.75);*/
    color: #4F4D78;
    font-size: 0.16rem;
    box-sizing: border-box;
    i {
      /*color: rgba(255, 255, 255, 0.75);*/
      color: #4F4D78;
    }
  }
  .subItem {
    // padding-left: 0.55rem !important;
    box-sizing: border-box;
    width: 100%;
    /deep/ .el-submenu__title {
      width: 100%;
      padding: 0 !important;
      padding-left: 0.55rem !important;
      color: #4F4D78 !important;
      i {
        color: #4F4D78 !important;
      }
    }
    &.is-opened {
    /deep/ .el-submenu__title {
      /*color: #fff;*/
      color: #37B5AA !important;
      i {
        /*color: #fff;*/
        color: #37B5AA !important;
      }
    }
  }
    /deep/ li.el-menu-item {
        padding-left: 0.75rem !important;
        background: red;
        width: 100%;
      }
  }
  // 
  .el-menu-item.is-active {
    /*color: #fff;*/
    color: #37B5AA;
  }

  /deep/ .el-submenu__title {
    /*color: rgba(255, 255, 255, 0.75);*/
    color: #4F4D78;
    i {
      /*color: rgba(255, 255, 255, 0.75);*/
      color: #4F4D78;
    }
  }

  .is-opened {
    /deep/ .el-submenu__title {
      /*color: #fff;*/
      color: #37B5AA;
      i {
        /*color: #fff;*/
        color: #37B5AA;
      }
    }
    .el-menu-item {
      background-color: #E4E8F3 !important;
    }
  }

  .router-link-active .el-menu-item {
    /*color: #fff;*/
    color: #37B5AA;
    background-color: #fff !important;
    i {
      /*color: #fff;*/
      color: #37B5AA;
    }
  }

  .el-submenu .el-menu-item {
    padding: 0 0.2rem 0 0.55rem !important;
    box-sizing: border-box;
    /*min-width: 180px;*/
  }

  .app-sidebar-top div {
    display: inline-block;
    font-size: 14px;
    color: #fff;
  }

  .app-sidebar-avatar img {
    width: 100%;
  }
}
</style>
